module.exports = __webpack_public_path__ + "img/mi-announcement.6a4a6371.svg";